import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalContentViolationNotChecked',
  props: {
    violation: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})